import { useQuery } from '@tanstack/react-query';
import { fetchActiveJob } from './api';

/**
 * Polls the Activity active-job endpoint at the same cadence as the queue.
 *
 * The active-job panel takes priority over the queue when a job is in flight,
 * so it needs to be roughly as fresh as the queue. Polling at 5s matches.
 */
export function useActiveJob(accessToken: string | undefined) {
  return useQuery({
    queryKey: ['discord-activity-active-job'],
    queryFn: () => fetchActiveJob(accessToken!),
    enabled: Boolean(accessToken),
    refetchInterval: 5_000,
    refetchIntervalInBackground: true,
    retry: 1,
    staleTime: 0,
  });
}
